import { FavoritesWidget } from './FavoritesWidget';
import { ClickedElement, IFavoritesWidget, ItemId } from './types';

export function createFavoritesWidget(el: Element): IFavoritesWidget {
    const service = new FavoritesWidget(el);

    return {
        count: service.count,
        toggle(event: Event, el: ClickedElement, itemId: ItemId, deleteCard?: boolean) {
            return service.toggle(event, el, itemId, deleteCard);
        },
    };
}
